var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 137,
    viewBox: "0 0 161 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.132 17.5204C121.572 10.9013 89.6349 18.575 59.9877 38.8222C30.3404 59.0694 11.5564 86.0112 10.5894 106.635L5.72754 109.962L14.9204 123.428C28.7657 143.701 71.3916 138.71 110.12 112.265C148.848 85.8201 169.034 47.9419 155.194 27.6957L146.001 14.2297L141.132 17.5204Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.919 98.8033C139.653 72.3597 159.828 34.4823 145.983 14.2018C132.137 -6.07879 89.513 -1.08278 50.7794 25.3608C12.0459 51.8045 -8.12969 89.682 5.71595 109.963C19.5616 130.243 62.1854 125.247 100.919 98.8033Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8126 86.9167C123.352 66.0674 140.123 37.468 130.271 23.0381C120.42 8.60824 87.6769 13.8121 57.1376 34.6615C26.5983 55.5108 9.82754 84.1103 19.6789 98.5402C29.5303 112.97 62.2733 107.766 92.8126 86.9167Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin6);
export default __webpack_public_path__ + "static/media/coin6.00f079a1f0bf957acdd32e728c714b77.svg";
export { ForwardRef as ReactComponent };